export default function DotdotdotIcon({ width, height, ...rest }: React.SVGProps<any>) {
  return (
    <svg width={width} height={height} viewBox="0 0 29 7" {...rest}>
      <path
        d="M18.056 3.5c0 1.932-1.593 3.5-3.556 3.5s-3.556-1.568-3.556-3.5S12.537 0 14.5 0s3.556 1.568 3.556 3.5zM25.444 0c-1.964 0-3.557 1.568-3.557 3.5S23.48 7 25.444 7C27.407 7 29 5.432 29 3.5S27.407 0 25.444 0zM3.556 0C1.593 0 0 1.568 0 3.5S1.593 7 3.556 7C5.52 7 7.113 5.432 7.113 3.5S5.52 0 3.556 0z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  );
}
